import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import Commands from '../../constants/commands';
import { LdapSubCmds } from '../../constants/sub-commands';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { ExecuteCommand } from "../../models/ExecuteCommand";
import { executeCommand } from '../../services/executeCommandService';
import { getErrorMessage } from "../../services/utilities/ServiceError";
import { useDialog } from '../dialog/DialogContext';
import ChooseModal from "@/components/choose-modal/ChooseModal.tsx";

interface ChooseCnModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

const ChooseCnModal: React.FC<ChooseCnModalProps> = ({ isOpen, setIsOpen }) => {
    const { translate } = useLocale();
    const dialog = useDialog();
    const { values, setFieldValue, setFieldTouched } = useFormikContext<any>();
    const [listItems, setListItems] = useState(new Array(0));
    const [commonNameResults, setCommonNameResults] = useState<any[]>([]);

    const getCommonNames = async () => {
        const command: ExecuteCommand = {
            cmd: Commands.Account.label,
            cmdSubType: LdapSubCmds.LDAP_SEARCH_USERS_BY_CN,
            searchTerm: values.searchByCn,
        }

        await executeCommand(command).then((response: any) => {
            setCommonNameResults(response.message);
        }).catch((error) => {
            dialog.pushError({ message: getErrorMessage(error), title: translate.byKey(TranslationKeys.error) })
        });
    }

    // Needs to be async to give formik a chance to realise
    // that the values have been updated.
    const handleSelectedCn = async (cn: any) => {
        await setFieldValue('ulCommonName', cn.displayName);
        await setFieldValue('uniqueIdentifier', cn.uid);
        setCommonNameResults(new Array(0));
        setFieldTouched('uniqueIdentifier', true);
        setFieldValue('searchByCn', null);
        setIsOpen(false);
    }

    const buildListItem = (item) => {
        return {
            value: item,
            isSelected: false,
            label: item.displayName,
            site: null,
            optionalColumns: null
        };
    };

    useEffect(() => {
        setListItems(commonNameResults!.map(buildListItem));
    }, [commonNameResults]);

    return <ChooseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title={translate.byKey(TranslationKeys.ldapPerson)}
            subtitle={translate.byKey(TranslationKeys.searchByCn)}
            getCommonNames={getCommonNames}
            rowSelect={handleSelectedCn}
            listItems={listItems}/>
}

export default ChooseCnModal;
